/**
 * Discount-reason options for the wrap-up invoice discount dialogs — the per-line discount
 * (`InvoiceEditServiceDialog`) and the invoice-wide management discount
 * (`InvoiceManagementDiscountDialog`).
 *
 * A local copy of the `DISCOUNT_REASONS` list in pm-react's
 * `src/billing/components/edit-service-discount-dialog.tsx` and
 * `management-discount-dialog.tsx` (the Edit appointment → Billing tab). There is no shared
 * package, so the list is mirrored here. pm-react took it verbatim from Flutter
 * `add_management_discount_popup.dart:48-55`.
 *
 * There is no endpoint behind it: the chosen label itself is what ships, as `discountReason`
 * (per-line) or `reason` (management discount). Keep the strings byte-identical to pm-react so
 * both apps write the same values.
 */
export const DISCOUNT_REASONS = [
  'Staff Discount',
  'Special discount',
  'Referral discount',
  'Package Discount',
  'Charity Discount',
  'Administrative approval discount',
] as const;

export type DiscountReason = (typeof DISCOUNT_REASONS)[number];

/** The list as DS `Select` options (label and value are the same string). */
export const DISCOUNT_REASON_OPTIONS = DISCOUNT_REASONS.map((r) => ({ label: r, value: r }));

/** True when `value` is one of the listed reasons (a legacy free-text reason is not). */
export function isDiscountReason(value: string | null | undefined): value is DiscountReason {
  return !!value && (DISCOUNT_REASONS as readonly string[]).includes(value);
}
